
const SubHeadingTitle = ({subTitle,style}) => {
  return (
    <p className={style}>
      {subTitle || ""}
    </p>
  )
}

export default SubHeadingTitle
